//data for Adidoo IT Firm Website
import ecom from './assets/ecom.webp';
import cor from './assets/cor.webp';
import cloud from './assets/cloud.webp';
import med from './assets/med.webp';
import logistic from './assets/logistic.webp';
import attendance from './assets/attendance.webp';
import odoo from './assets/odoo.webp';
import whyodoo from './assets/whyodoo.webp';
import app from './assets/app.webp';
import cybersecurity from './assets/cybersecurity.webp';

export const content = {
  en: {
    // Header
    nav: {
      home: 'Home',
      services: 'Services',
      offers: 'New Year Offers',
      portfolio: 'Portfolio',
      team: 'Team',
      blog: 'Blog',
      contact: 'Contact',
      getStarted: 'Get Started'
    },

    // Hero Section
    hero: {
      title: 'Transform Your Business',
      subtitle: 'with Next-Generation IT Solutions',
      description: 'Leading IT services provider in Saudi Arabia. We deliver cutting-edge Odoo ERP, custom applications, and cloud solutions that drive business growth.',
      cta1: 'Start Your Project',
      cta2: 'View Our Services',
      stats: [
        { value: '500+', label: 'Projects Completed' },
        { value: '200+', label: 'Happy Clients' },
        { value: '15+', label: 'Years Experience' },
        { value: '50+', label: 'Expert Team' }
      ]
    },

    // Services Section
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive IT Solutions Tailored to Your Needs',
      items: [
        {
          title: 'Odoo ERP Implementation',
          description: 'Complete Odoo ERP solutions with customization, implementation, training, and ongoing support for seamless business operations.',
          features: ['Custom Modules', 'Data Migration', 'Training & Support', 'Integration Services']
        },
        {
          title: 'Full Stack Development',
          description: 'End-to-end web application development using modern technologies like React, Node.js, Python, and more.',
          features: ['Scalable Architecture', 'API Development', 'Database Design', 'Performance Optimization']
        },
        {
          title: 'Mobile Applications',
          description: 'Native and cross-platform mobile apps for iOS and Android that deliver exceptional user experiences.',
          features: ['iOS & Android', 'React Native', 'Flutter', 'App Store Deployment']
        },
        {
          title: 'Website Development',
          description: 'Professional, responsive websites that engage your audience and drive conversions.',
          features: ['Responsive Design', 'SEO Optimized', 'CMS Integration', 'E-commerce Solutions']
        },
        {
          title: 'Cybersecurity Consulting Services',
          description: 'End-to-end cybersecurity consulting focused on risk management, ISO 27001 compliance, and secure business operations.',
          features: ['Security Policy & Framework Development', 'Security awareness & Training', 'ISO 27001 ']
        },
        {
          title: 'IT Consulting',
          description: 'Strategic IT consulting to help you make informed technology decisions and optimize your digital infrastructure.',
          features: ['Digital Strategy', 'Technology Audit', 'System Integration', 'Security Consulting']
        }
      ]
    },

    // New Year Offers
    offers: {
      title: '2026 New Year Special Offers',
      subtitle: 'Start the Year with Amazing Savings',
      badge: 'Limited Time',
      items: [
        {
          title: 'Odoo ERP Starter Package',
          discount: '30% OFF',
          originalPrice: 'SAR 50,000',
          newPrice: 'SAR 35,000',
          description: 'Complete Odoo implementation with 3 modules',
          features: ['3 Custom Modules', '2 Weeks Implementation', '1 Month Support', 'Training Included'],
          validity: 'Valid until January 31, 2026'
        },
        {
          title: 'Website + Mobile App Bundle',
          discount: '40% OFF',
          originalPrice: 'SAR 80,000',
          newPrice: 'SAR 48,000',
          description: 'Professional website with companion mobile application with basic features',
          features: ['Responsive Website', 'iOS + Android App', 'Admin Panel', '6 Months Support'],
          validity: 'Valid until February 15, 2026'
        },
        {
          title: 'Cyber Security Assessment Package',
          discount: '25% OFF',
          originalPrice: 'SAR 40,000',
          newPrice: 'SAR 30,000',
          description: 'Comprehensive cyber security assessment aligned with ISO 27001 best practices',
          features: [
            'Security Risk Assessment',
            'Vulnerability & Gap Analysis',
            'Policy & Compliance Review',
            'Actionable Security Roadmap'
          ],
          validity: 'Valid until January 31, 2026'
        }

      ]
    },

    // Portfolio Section
    portfolio: {
      title: 'Our Work',
      subtitle: 'Successful Projects That Made a Difference',
      items: [
        {
          title: 'E-Commerce Platform',
          category: 'Full Stack Development',
          description: 'Complete e-commerce solution with inventory management and multi-vendor support',
          client: 'Retail Chain KSA',
          image: ecom,
        },
        {
          title: 'Healthcare Management System',
          category: 'Odoo ERP',
          description: 'Custom Odoo ERP for hospital management with patient records and billing',
          client: 'Medical Center Riyadh',
          image: med,
        },
        {
          title: 'Logistics Mobile App',
          category: 'Mobile Development',
          description: 'Real-time tracking and delivery management mobile application',
          client: 'Logistics Company',
          image: logistic,
        },
        {
          title: 'Corporate Website',
          category: 'Web Development',
          description: 'Modern corporate website with multi-language support and CMS',
          client: 'Construction Firm',
          image: cor,
        },
        {
          title: 'Cybersecurity Framework Implementation',
          category: 'Cybersecurity Consulting',
          description: 'Implemented ISO 27001 framework and enhanced security posture',
          client: 'Accounting Startup',
          image: cloud,
        },
        {
          title: 'Attendance Portal',
          category: 'Full Stack Development',
          description: 'Secure online attendance portal with advanced security features',
          client: 'Financial Institution',
          image: attendance
        }
      ]
    },

    // Team Section
    team: {
      title: 'Meet Our Expert Team',
      subtitle: 'Experienced Professionals Dedicated to Your Success',
      members: [
        {
          name: 'Oday Fahad Aldubai',
          position: 'CEO',
          bio: '8+ years in IT consulting and ERP implementation',
          expertise: ['Business Strategy', 'ERP Systems', 'Team Leadership']
        },
        {
          name: 'Ahmed Nour',
          position: 'Lead Odoo Developer',
          bio: 'Certified Odoo expert with 100+ implementations',
          expertise: ['Odoo Customization', 'Python Development', 'ERP Integration']
        },
        {
          name: 'Gokul Koyattassery',
          position: 'Lead Full-Stack Developer',
          bio: 'Expert in Mobile and full-stack development',
          expertise: ['Web Development', 'App Development', 'DevOps']
        },
        {
          name: 'Abdullah AlTuraif',
          position: 'Information Technology Specialist',
          bio: 'Information Technology specialist with ITIL 4 certification and a bachelor\'s degree',
          expertise: ['ITIL 4', 'Information Technology', 'Bachelor\'s Degree']
        },

      ]
    },

    // Testimonials
    testimonials: {
      title: 'What Our Clients Say',
      subtitle: 'Trusted by Leading Businesses Across Saudi Arabia',
      items: [
        {
          quote: 'Adidoo transformed our business operations with their Odoo implementation. The team was professional, knowledgeable, and always available.',
          author: 'Enterprise Client',
          position: 'Operations Manager',
          company: 'Trading Company · Saudi Arabia'
        },
        {
          quote: 'Outstanding work on our mobile app! They delivered beyond expectations and provided excellent post-launch support.',
          author: 'Retail Sector Client',
          position: 'Marketing Director',
          company: 'E-Commerce Business · KSA'
        },
        {
          quote: 'The cloud migration was seamless. Our system performance improved by 300% and costs reduced significantly.',
          author: 'Technology Partner',
          position: 'IT Director',
          company: 'Corporate Client · GCC'
        },
        {
          quote: 'Professional team with deep technical expertise. They understood our requirements perfectly and delivered a robust solution.',
          author: 'Manufacturing Client',
          position: 'CEO',
          company: 'Industrial Group · Saudi Arabia'
        }
      ]
    },

    // Blog Section
    blog: {
      title: 'Latest Insights',
      subtitle: 'Stay Updated with Technology Trends and Best Practices',
      items: [
        {
          id: 'odoo-19-whats-new',
          slug: 'odoo-19-whats-new-upgrade',
          title: 'Odoo 19: What\'s New and Why You Should Upgrade',
          excerpt: 'Discover the latest features in Odoo 19 and how they can benefit your business operations.',
          category: 'ERP',
          date: 'December 28, 2025',
          readTime: '5 min read',
          image: odoo,
          author: 'Ahmed Nour',
          authorRole: 'Lead Odoo Developer',
          content: {
            intro: 'Odoo 19 has arrived with groundbreaking features that transform how businesses manage their operations. This comprehensive guide explores everything you need to know about the latest release.',
            sections: [
              {
                heading: 'Enhanced User Interface',
                text: 'Odoo 19 introduces a completely redesigned interface with improved navigation, modern aesthetics, and better mobile responsiveness. The new UI reduces clicks and streamlines workflows, making it easier for teams to accomplish tasks quickly.'
              },
              {
                heading: 'AI-Powered Features',
                text: 'Artificial Intelligence integration brings smart automation to Odoo 19. From predictive analytics in inventory management to intelligent document processing, AI capabilities help businesses make data-driven decisions faster than ever before.'
              },
              {
                heading: 'Advanced Reporting',
                text: 'The new reporting engine offers real-time insights with customizable dashboards. Users can create complex reports without technical knowledge, and the system automatically updates data for accurate decision-making.'
              },
              {
                heading: 'Integration Capabilities',
                text: 'Odoo 19 expands its API ecosystem, making it easier to connect with third-party applications. Whether you\'re integrating with e-commerce platforms, payment gateways, or shipping providers, the enhanced API documentation and tools simplify the process.'
              },
              {
                heading: 'Performance Improvements',
                text: 'With optimized database queries and improved caching mechanisms, Odoo 19 delivers up to 40% faster load times. Large enterprises with millions of records will notice significant performance gains.'
              }
            ],
            conclusion: 'Upgrading to Odoo 19 is a strategic investment in your business\'s digital future. The new features not only improve efficiency but also provide competitive advantages in today\'s fast-paced market. Contact Adidoo today to plan your smooth migration to Odoo 19.'
          },
          tags: ['Odoo', 'ERP', 'Software Update', 'Business Software', 'Odoo 19']
        },
        {
          id: 'attendance-system-guide',
          slug: 'attendance-system-complete-guide-saudi-sme',
          title: 'Attendance System: A Complete Guide for Saudi Small & Medium Enterprises',
          excerpt: 'Everything you need to know about implementing an attendance system in 2026.',
          category: 'Full Stack Development',
          date: 'December 25, 2025',
          readTime: '8 min read',
          image: attendance,
          author: 'Gokul Koyattassery',
          authorRole: 'Lead Full Stack Developer',
          content: {
            intro: 'In the modern Saudi business landscape, efficient attendance tracking is crucial for compliance, payroll accuracy, and workforce management. This comprehensive guide helps SMEs choose and implement the right attendance system.',
            sections: [
              {
                heading: 'Why Attendance Systems Matter in Saudi Arabia',
                text: 'Saudi labor laws require accurate employee time tracking for compliance with work hour regulations and overtime calculations. Modern attendance systems not only ensure legal compliance but also provide insights into workforce productivity and help optimize staffing levels.'
              },
              {
                heading: 'Types of Attendance Systems',
                text: 'Biometric systems use fingerprints or facial recognition for secure clock-ins. Cloud-based systems offer mobile accessibility and real-time tracking. RFID card systems provide contactless convenience. Each type has unique advantages depending on your business needs and budget.'
              },
              {
                heading: 'Key Features to Look For',
                text: 'Essential features include automated overtime calculation, shift management, leave integration, mobile accessibility, and real-time reporting. For Saudi businesses, Arabic language support and Hijri calendar integration are critical requirements.'
              },
              {
                heading: 'Integration with Payroll and HR',
                text: 'Modern attendance systems seamlessly integrate with payroll software, eliminating manual data entry and reducing errors. Integration with HR systems enables comprehensive employee management, from onboarding to performance reviews.'
              },
              {
                heading: 'Implementation Best Practices',
                text: 'Start with a clear requirements assessment. Train employees thoroughly on the new system. Implement in phases to minimize disruption. Ensure backup systems are in place. Regularly review and optimize based on user feedback and business needs.'
              },
              {
                heading: 'Compliance and Data Security',
                text: 'Attendance data contains sensitive employee information. Ensure your system complies with Saudi data protection regulations. Implement encryption, access controls, and regular security audits. Choose vendors who understand local compliance requirements.'
              },
              {
                heading: 'Cost Considerations',
                text: 'Initial costs include hardware, software licenses, and installation. Factor in ongoing costs like maintenance, support, and upgrades. Cloud-based solutions typically offer predictable monthly pricing, while on-premise systems require larger upfront investments but lower recurring costs.'
              }
            ],
            conclusion: 'Implementing an attendance system is an investment in operational efficiency and legal compliance. For Saudi SMEs, choosing a solution that understands local requirements and integrates with existing systems is crucial. Adidoo specializes in custom attendance solutions tailored to Saudi businesses. Contact us for a free consultation and demo.'
          },
          tags: ['Attendance System', 'HR Technology', 'Saudi Arabia', 'SME', 'Workforce Management']
        },
        {
          id: 'mobile-app-trends-2026',
          slug: 'mobile-app-development-trends-2026',
          title: 'Mobile App Development Trends in 2026',
          excerpt: 'Explore the latest mobile development trends that will shape the industry this year.',
          category: 'Mobile',
          date: 'December 22, 2025',
          readTime: '6 min read',
          image: app,
          author: 'Oday Fahad Aldubai',
          authorRole: 'CEO',
          content: {
            intro: 'The mobile app development landscape continues to evolve rapidly. As we enter 2026, new technologies and user expectations are reshaping how we build mobile applications. Here are the key trends every business should know.',
            sections: [
              {
                heading: 'AI and Machine Learning Integration',
                text: 'AI is no longer optional in mobile apps. From personalized recommendations to predictive text and image recognition, machine learning models are becoming standard features. Edge AI allows processing directly on devices, providing faster responses and enhanced privacy.'
              },
              {
                heading: 'Super Apps Rise in Popularity',
                text: 'Following the success of WeChat and Grab, super apps that combine multiple services in one platform are gaining traction globally. Users prefer consolidated experiences over juggling multiple apps. This trend is particularly strong in emerging markets and the GCC region.'
              },
              {
                heading: '5G-Powered Experiences',
                text: 'With 5G networks expanding across Saudi Arabia and the Gulf, apps can now deliver richer content, real-time multiplayer experiences, and high-quality video streaming without buffering. Developers are creating apps that fully leverage these capabilities.'
              },
              {
                heading: 'Cross-Platform Development Maturity',
                text: 'Flutter and React Native have matured significantly, offering near-native performance with single codebase advantages. More enterprises are choosing cross-platform approaches to reduce development costs and speed time-to-market while maintaining quality.'
              },
              {
                heading: 'Enhanced Security and Privacy',
                text: 'With increasing data breaches, users demand stronger security. Biometric authentication is standard, zero-trust architectures are emerging, and privacy-first designs are becoming competitive advantages. Apps that transparently handle data earn user trust.'
              },
              {
                heading: 'Augmented Reality Goes Mainstream',
                text: 'AR is moving beyond gaming and filters. Retail apps use AR for virtual try-ons, real estate apps for virtual tours, and education apps for interactive learning. The technology is becoming accessible and practical for everyday business applications.'
              }
            ],
            conclusion: 'Staying ahead in mobile app development requires understanding these trends and knowing when to adopt them. Not every trend suits every business, but being informed helps make strategic decisions. Adidoo\'s mobile development team stays at the forefront of these technologies, delivering cutting-edge apps for Saudi businesses. Let\'s discuss your mobile app vision.'
          },
          tags: ['Mobile Development', 'App Trends', 'Technology', 'iOS', 'Android', '2026']
        },
        {
          id: 'why-odoo-better-than-other-erp',
          slug: 'why-odoo-is-better-than-other-erp-systems',
          title: 'Why Odoo Is Better Than Traditional ERP Systems',
          excerpt: 'Odoo has redefined what modern ERP should be—flexible, scalable, cost-effective, and built for real business needs. Here’s why it consistently outperforms legacy ERP systems.',
          category: 'ERP',
          date: 'January 2026',
          readTime: '6 min read',
          image: whyodoo,
          author: 'Ahmed Nour',
          authorRole: 'Lead Odoo Developer',
          content: {
            intro: 'Most ERP systems were designed for a different era—slow, rigid, expensive, and hostile to change. Odoo breaks that pattern. It is not just another ERP; it is a modular business platform built for companies that need to move fast, adapt constantly, and stay in control of costs.',
            sections: [
              {
                heading: 'True Modular Architecture',
                text: 'Unlike monolithic ERP systems that force you to buy everything upfront, Odoo is modular by design. You implement only what you need—Sales, Accounting, Inventory, HR, Manufacturing—and scale as the business grows. No wasted licenses. No bloated implementations.'
              },
              {
                heading: 'Lower Total Cost of Ownership',
                text: 'Traditional ERP systems drain budgets through licensing fees, forced upgrades, and vendor lock-in. Odoo offers transparent pricing, open-source flexibility, and freedom of customization. Businesses get enterprise-grade capability without enterprise-grade financial pain.'
              },
              {
                heading: 'Faster Implementation, Faster ROI',
                text: 'ERP projects fail when they take too long. Odoo implementations are faster because the system is intuitive, configurable, and developer-friendly. Businesses go live sooner, adapt quicker, and start seeing ROI in months—not years.'
              },
              {
                heading: 'One Platform, Fully Integrated',
                text: 'Most ERPs rely on fragile integrations between disconnected modules. Odoo is built as one unified platform. Sales talks to Inventory. Inventory talks to Accounting. Data flows cleanly, consistently, and in real time—without middleware chaos.'
              },
              {
                heading: 'Designed for Users, Not Just Consultants',
                text: 'Legacy ERPs are powerful but painful. Odoo focuses on usability. Clean interfaces, logical workflows, and modern UX mean teams actually use the system instead of working around it. Adoption is higher, errors are lower, and productivity improves.'
              },
              {
                heading: 'Open, Flexible, and Future-Proof',
                text: 'Odoo is open-source at its core. That means no vendor lock-in and unlimited customization. As your business evolves, Odoo evolves with you—new modules, new automations, new integrations. You are not trapped by yesterday’s decisions.'
              }
            ],
            conclusion: 'Odoo wins because it aligns with how modern businesses actually operate—fast, digital, and constantly changing. It delivers power without complexity and flexibility without chaos. Compared to traditional ERP systems, Odoo is not just better. It is smarter.'
          },
          tags: [
            'Odoo',
            'ERP',
            'Business Software',
            'Digital Transformation',
            'Enterprise Systems',
            'Odoo Benefits'
          ]
        },
        {
          id: 'saudi-cyber-security-iso-27001',
          slug: 'saudi-arabia-cyber-security-iso-27001-importance',
          title: 'Why Cyber Security and ISO 27001 Are No Longer Optional in Saudi Arabia',
          excerpt: 'As Saudi Arabia accelerates its digital transformation, cyber security and ISO 27001 compliance have become critical pillars for business resilience, trust, and regulatory survival.',
          category: 'Cyber Security',
          date: 'January 2026',
          readTime: '6 min read',
          image: cybersecurity,
          author: '',
          authorRole: 'Lead Cyber Security Consultant',
          content: {
            intro: 'Saudi Arabia is moving fast. Vision 2030 is digitizing everything—government services, financial systems, healthcare, energy, and logistics. Speed is an advantage, but it also paints a target. Cyber threats are rising in volume, sophistication, and financial impact. In this environment, cyber security is not an IT concern. It is a board-level survival issue.',
            sections: [
              {
                heading: 'The Cyber Threat Landscape in Saudi Arabia',
                text: 'Saudi organizations are among the most targeted in the Middle East. Financial institutions, government entities, oil and gas companies, and healthcare providers face constant threats ranging from ransomware and data breaches to nation-state attacks. Attackers are not experimenting—they are exploiting gaps in governance, access control, and incident response.'
              },
              {
                heading: 'Why ISO 27001 Matters More Than Ever',
                text: 'ISO 27001 is not paperwork. It is a structured, globally recognized framework that forces organizations to understand their risks, control their assets, and respond effectively to incidents. In Saudi Arabia, ISO 27001 aligns directly with regulatory expectations, NCA requirements, and customer trust. It replaces guesswork with discipline.'
              },
              {
                heading: 'Cyber Security as a Business Enabler',
                text: 'Strong cyber security is not a blocker—it is an accelerator. Organizations with mature security programs move faster because they trust their systems. They onboard partners confidently, adopt cloud technologies safely, and scale without fear. Security enables growth when it is embedded, not bolted on.'
              },
              {
                heading: 'Regulatory Pressure Is Increasing',
                text: 'Saudi regulators are raising the bar. Compliance with national cyber security frameworks is no longer optional, and enforcement is becoming stricter. Organizations that delay investment in information security governance will pay later—through fines, operational disruption, or reputational damage.'
              },
              {
                heading: 'The Cost of Inaction',
                text: 'A single breach can erase years of growth. Data loss, service downtime, legal exposure, and public loss of trust are not hypothetical risks—they are daily realities. Organizations that treat cyber security as an afterthought are gambling with their future.'
              }
            ],
            conclusion: 'In Saudi Arabia’s digital economy, cyber security is a strategic asset. ISO 27001 provides the structure, clarity, and credibility organizations need to protect themselves and grow with confidence. The question is no longer whether to invest in cyber security—but whether you can afford not to.'
          },
          tags: [
            'Cyber Security',
            'ISO 27001',
            'Saudi Arabia',
            'Information Security',
            'Risk Management',
            'Vision 2030'
          ]
        }
        ,
      ]
    },


    // Contact Section
    contact: {
      title: 'Get in Touch',
      subtitle: 'Let\'s Discuss Your Next Project',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        company: 'Company Name',
        service: 'Service Interested In',
        message: 'Project Details',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully! We\'ll get back to you soon.',
        error: 'Failed to send message. Please try again.'
      },
      info: {
        email: 'info@adidoo.com',
        phone: '+966 551826405',
        address: 'Riyadh, Saudi Arabia',
        hours: 'Sun - Thu: 9:00 AM - 6:00 PM'
      }
    },

    // Footer
    footer: {
      tagline: 'Transforming businesses with innovative IT solutions',
      company: {
        title: 'Company',
        links: ['About Us', 'Careers', 'Partners', 'News']
      },
      services: {
        title: 'Services',
        links: ['Odoo ERP', 'Web Development', 'Mobile Apps', 'Cyber Security', 'IT Consulting']
      },
      support: {
        title: 'Support',
        links: ['Documentation', 'Help Center', 'Contact Us', 'FAQs']
      },
      legal: {
        title: 'Legal',
        links: ['Privacy Policy', 'Terms of Service', 'Cookie Policy']
      },
      copyright: '© 2026 Adidoo. All rights reserved.'
    }
  },

 ar: {
    // Header
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      offers: 'عروض العام الجديد',
      portfolio: 'أعمالنا',
      team: 'الفريق',
      blog: 'المدونة',
      contact: 'اتصل بنا',
      getStarted: 'ابدأ الآن'
    },

    // Hero Section
    hero: {
      title: 'حوّل أعمالك',
      subtitle: 'بحلول تقنية من الجيل القادم',
      description: 'مزود رائد لخدمات تقنية المعلومات في المملكة العربية السعودية. نقدم حلول Odoo ERP المتطورة والتطبيقات المخصصة والحلول السحابية التي تدفع نمو الأعمال.',
      cta1: 'ابدأ مشروعك',
      cta2: 'شاهد خدماتنا',
      stats: [
        { value: '+500', label: 'مشروع منجز' },
        { value: '+200', label: 'عميل راضٍ' },
        { value: '+15', label: 'سنة خبرة' },
        { value: '+50', label: 'فريق خبراء' }
      ]
    },

    // Services Section
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول تقنية شاملة مصممة حسب احتياجاتك',
      items: [
        {
          title: 'تطبيق Odoo ERP',
          description: 'حلول Odoo ERP متكاملة مع التخصيص والتطبيق والتدريب والدعم المستمر لعمليات أعمال سلسة.',
          features: ['وحدات مخصصة', 'نقل البيانات', 'التدريب والدعم', 'خدمات التكامل']
        },
        {
          title: 'تطوير Full Stack',
          description: 'تطوير تطبيقات ويب شامل من البداية للنهاية باستخدام تقنيات حديثة مثل React و Node.js و Python والمزيد.',
          features: ['بنية قابلة للتوسع', 'تطوير واجهات برمجية', 'تصميم قواعد البيانات', 'تحسين الأداء']
        },
        {
          title: 'تطبيقات الجوال',
          description: 'تطبيقات جوال أصلية ومتعددة المنصات لأنظمة iOS و Android تقدم تجارب مستخدم استثنائية.',
          features: ['iOS و Android', 'React Native', 'Flutter', 'النشر على متجر التطبيقات']
        },
        {
          title: 'تطوير المواقع الإلكترونية',
          description: 'مواقع إلكترونية احترافية ومتجاوبة تجذب جمهورك وتزيد من التحويلات.',
          features: ['تصميم متجاوب', 'محسّن لمحركات البحث', 'تكامل أنظمة إدارة المحتوى', 'حلول التجارة الإلكترونية']
        },
        {
          title: 'خدمات الاستشارات في الأمن السيبراني',
          description: 'استشارات أمن سيبراني شاملة من البداية للنهاية تركز على إدارة المخاطر والامتثال لمعيار ISO 27001 وعمليات الأعمال الآمنة.',
          features: [ 'التوعية والتدريب في الأمن السيبراني', 'ISO 27001', 'استخبارات التهديدات السيبرانية']
        },
        {
          title: 'الاستشارات التقنية',
          description: 'استشارات تقنية استراتيجية لمساعدتك على اتخاذ قرارات تقنية مدروسة وتحسين بنيتك التحتية الرقمية.',
          features: ['الاستراتيجية الرقمية', 'مراجعة تقنية', 'تكامل الأنظمة', 'استشارات الأمن']
        }
      ]
    },

    // New Year Offers
    offers: {
      title: 'عروض العام الجديد 2026 الخاصة',
      subtitle: 'ابدأ العام بتوفيرات مذهلة',
      badge: 'لفترة محدودة',
      items: [
        {
          title: 'باقة Odoo ERP للمبتدئين',
          discount: 'خصم 30%',
          originalPrice: '50,000 ريال',
          newPrice: '35,000 ريال',
          description: 'تطبيق Odoo كامل مع 3 وحدات',
          features: ['3 وحدات مخصصة', 'تطبيق خلال أسبوعين', 'دعم لمدة شهر', 'التدريب مشمول'],
          validity: 'صالح حتى 31 يناير 2026'
        },
        {
          title: 'باقة موقع إلكتروني + تطبيق جوال',
          discount: 'خصم 40%',
          originalPrice: '80,000 ريال',
          newPrice: '48,000 ريال',
          description: 'موقع إلكتروني احترافي مع تطبيق جوال مرافق بميزات أساسية',
          features: ['موقع متجاوب', 'تطبيق iOS + Android', 'لوحة تحكم', 'دعم لمدة 6 أشهر'],
          validity: 'صالح حتى 15 فبراير 2026'
        },
        {
          title: 'باقة تقييم الأمن السيبراني',
          discount: 'خصم 25%',
          originalPrice: '40,000 ريال',
          newPrice: '30,000 ريال',
          description: 'تقييم شامل للأمن السيبراني متوافق مع أفضل ممارسات ISO 27001',
          features: [
            'تقييم مخاطر الأمان',
            'تحليل الثغرات والفجوات',
            'مراجعة السياسات والامتثال',
            'خارطة طريق أمنية قابلة للتنفيذ'
          ],
          validity: 'صالح حتى 31 يناير 2026'
        }
      ]
    },

    // Portfolio Section
    portfolio: {
      title: 'أعمالنا',
      subtitle: 'مشاريع ناجحة أحدثت فرقاً',
      items: [
        {
          title: 'منصة التجارة الإلكترونية',
          category: 'تطوير Full Stack',
          description: 'حل تجارة إلكترونية متكامل مع إدارة المخزون ودعم متعدد البائعين',
          client: 'سلسلة بيع بالتجزئة في المملكة',
          image: ecom,
        },
        {
          title: 'نظام إدارة الرعاية الصحية',
          category: 'Odoo ERP',
          description: 'نظام Odoo ERP مخصص لإدارة المستشفيات مع سجلات المرضى والفوترة',
          client: 'مركز طبي الرياض',
          image: med,
        },
        {
          title: 'تطبيق جوال للخدمات اللوجستية',
          category: 'تطوير الجوال',
          description: 'تطبيق جوال للتتبع الفوري وإدارة التسليم',
          client: 'شركة خدمات لوجستية',
          image: logistic,
        },
        {
          title: 'موقع إلكتروني للشركات',
          category: 'تطوير الويب',
          description: 'موقع إلكتروني حديث للشركات مع دعم متعدد اللغات ونظام إدارة المحتوى',
          client: 'شركة إنشاءات',
          image: cor,
        },
        {
          title: 'تطبيق إطار الأمن السيبراني',
          category: 'استشارات الأمن السيبراني',
          description: 'تطبيق إطار ISO 27001 وتعزيز الوضع الأمني',
          client: 'شركة محاسبة ناشئة',
          image: cloud,
        },
        {
          title: 'بوابة الحضور',
          category: 'تطوير Full Stack',
          description: 'بوابة حضور آمنة عبر الإنترنت مع ميزات أمان متقدمة',
          client: 'مؤسسة مالية',
          image: attendance
        }
      ]
    },

    // Team Section
    team: {
      title: 'تعرف على فريق الخبراء لدينا',
      subtitle: 'محترفون ذوو خبرة ملتزمون بنجاحك',
      members: [
        {
          name: 'عدي الضبيعي',
          position: 'الرئيس التنفيذي',
          bio: 'أكثر من 8 سنوات في الاستشارات التقنية وتطبيق أنظمة تخطيط موارد المؤسسات',
          expertise: ['استراتيجية الأعمال', 'أنظمة تخطيط موارد المؤسسات', 'قيادة الفريق']
        },
        {
          name: 'أحمد نور',
          position: 'مطور Odoo الرئيسي',
          bio: 'خبير Odoo معتمد مع أكثر من 100 عملية تطبيق',
          expertise: ['تخصيص Odoo', 'تطوير Python', 'تكامل أنظمة تخطيط الموارد']
        },
        {
          name: 'جوكول كوياتاسيري',
          position: 'مطور Full Stack الرئيسي',
          bio: 'خبير في تطوير الجوال وتطوير Full Stack',
          expertise: ['تطوير الويب', 'تطوير التطبيقات', 'DevOps']
        },
        {
          name: 'عبدالله الطريّف',
          position: 'اخصائي تقنية المعلومات',
          bio: 'أخصائي تقنية المعلومات حاصل على شهادة ITIL 4 ودرجة البكالوريوس',
          expertise: ['ITIL 4', 'تقنية المعلومات', 'بكالوريوس']
        },
      ]
    },

    // Testimonials
    testimonials: {
      title: 'ماذا يقول عملاؤنا',
      subtitle: 'موثوق به من قبل الشركات الرائدة في جميع أنحاء المملكة العربية السعودية',
      items: [
        {
          quote: 'حولت أديدو عمليات أعمالنا من خلال تطبيق Odoo. كان الفريق محترفاً وذو معرفة واسعة ومتاحاً دائماً.',
          author: 'عميل من المؤسسات',
          position: 'مدير العمليات',
          company: 'شركة تجارية · المملكة العربية السعودية'
        },
        {
          quote: 'عمل رائع على تطبيقنا الجوال! قدموا أكثر من التوقعات وقدموا دعماً ممتازاً بعد الإطلاق.',
          author: 'عميل من قطاع التجزئة',
          position: 'مدير التسويق',
          company: 'أعمال تجارة إلكترونية · المملكة'
        },
        {
          quote: 'كان الانتقال للسحابة سلساً. تحسن أداء نظامنا بنسبة 300% وانخفضت التكاليف بشكل كبير.',
          author: 'شريك تقني',
          position: 'مدير تقنية المعلومات',
          company: 'عميل من الشركات الكبرى · دول الخليج'
        },
        {
          quote: 'فريق محترف مع خبرة تقنية عميقة. فهموا متطلباتنا بشكل مثالي وقدموا حلاً قوياً.',
          author: 'عميل من قطاع التصنيع',
          position: 'الرئيس التنفيذي',
          company: 'مجموعة صناعية · المملكة العربية السعودية'
        }
      ]
    },

    // Blog Section
    blog: {
      title: 'أحدث الرؤى',
      subtitle: 'ابقَ على اطلاع باتجاهات التقنية وأفضل الممارسات',
      items: [
        {
          id: 'odoo-19-whats-new',
          slug: 'odoo-19-whats-new-upgrade',
          title: 'Odoo 19: ما الجديد ولماذا يجب عليك الترقية',
          excerpt: 'اكتشف أحدث الميزات في Odoo 19 وكيف يمكن أن تفيد عمليات أعمالك.',
          category: 'تخطيط موارد المؤسسات',
          date: '28 ديسمبر 2025',
          readTime: '5 دقائق قراءة',
          image: odoo,
          author: 'أحمد نور',
          authorRole: 'مطور Odoo الرئيسي',
          content: {
            intro: 'وصل Odoo 19 بميزات رائدة تحول الطريقة التي تدير بها الشركات عملياتها. يستكشف هذا الدليل الشامل كل ما تحتاج لمعرفته حول أحدث إصدار.',
            sections: [
              {
                heading: 'واجهة المستخدم المحسّنة',
                text: 'يقدم Odoo 19 واجهة معاد تصميمها بالكامل مع تنقل محسّن وجماليات حديثة واستجابة أفضل للجوال. تقلل الواجهة الجديدة من النقرات وتبسط سير العمل، مما يسهل على الفرق إنجاز المهام بسرعة.'
              },
              {
                heading: 'ميزات مدعومة بالذكاء الاصطناعي',
                text: 'يجلب تكامل الذكاء الاصطناعي الأتمتة الذكية إلى Odoo 19. من التحليلات التنبؤية في إدارة المخزون إلى معالجة المستندات الذكية، تساعد قدرات الذكاء الاصطناعي الشركات على اتخاذ قرارات مبنية على البيانات بشكل أسرع من أي وقت مضى.'
              },
              {
                heading: 'التقارير المتقدمة',
                text: 'يقدم محرك التقارير الجديد رؤى فورية مع لوحات معلومات قابلة للتخصيص. يمكن للمستخدمين إنشاء تقارير معقدة بدون معرفة تقنية، ويحدث النظام البيانات تلقائياً لاتخاذ قرارات دقيقة.'
              },
              {
                heading: 'قدرات التكامل',
                text: 'يوسع Odoo 19 نظام واجهاته البرمجية، مما يسهل الاتصال بتطبيقات الطرف الثالث. سواء كنت تتكامل مع منصات التجارة الإلكترونية أو بوابات الدفع أو مزودي الشحن، فإن الوثائق والأدوات المحسّنة للواجهات البرمجية تبسط العملية.'
              },
              {
                heading: 'تحسينات الأداء',
                text: 'مع استعلامات قاعدة البيانات المحسّنة وآليات التخزين المؤقت المحسّنة، يقدم Odoo 19 أوقات تحميل أسرع بنسبة تصل إلى 40%. ستلاحظ المؤسسات الكبيرة التي لديها ملايين السجلات مكاسب كبيرة في الأداء.'
              }
            ],
            conclusion: 'الترقية إلى Odoo 19 هي استثمار استراتيجي في المستقبل الرقمي لأعمالك. لا تعمل الميزات الجديدة على تحسين الكفاءة فحسب، بل توفر أيضاً مزايا تنافسية في سوق اليوم سريع الوتيرة. اتصل بأديدو اليوم للتخطيط لانتقالك السلس إلى Odoo 19.'
          },
          tags: ['Odoo', 'تخطيط موارد المؤسسات', 'تحديث البرمجيات', 'برامج الأعمال', 'Odoo 19']
        },
        {
          id: 'attendance-system-guide',
          slug: 'attendance-system-complete-guide-saudi-sme',
          title: 'نظام الحضور: دليل شامل للشركات الصغيرة والمتوسطة السعودية',
          excerpt: 'كل ما تحتاج لمعرفته حول تطبيق نظام الحضور في عام 2026.',
          category: 'تطوير Full Stack',
          date: '25 ديسمبر 2025',
          readTime: '8 دقائق قراءة',
          image: attendance,
          author: 'جوكول كوياتاسيري',
          authorRole: 'مطور Full Stack الرئيسي',
          content: {
            intro: 'في بيئة الأعمال السعودية الحديثة، يعد تتبع الحضور الفعال أمراً بالغ الأهمية للامتثال ودقة الرواتب وإدارة القوى العاملة. يساعد هذا الدليل الشامل الشركات الصغيرة والمتوسطة على اختيار وتطبيق نظام الحضور المناسب.',
            sections: [
              {
                heading: 'لماذا تهم أنظمة الحضور في المملكة العربية السعودية',
                text: 'تتطلب قوانين العمل السعودية تتبعاً دقيقاً لوقت الموظف للامتثال للوائح ساعات العمل وحسابات الوقت الإضافي. لا تضمن أنظمة الحضور الحديثة الامتثال القانوني فحسب، بل توفر أيضاً رؤى حول إنتاجية القوى العاملة وتساعد في تحسين مستويات التوظيف.'
              },
              {
                heading: 'أنواع أنظمة الحضور',
                text: 'تستخدم الأنظمة البيومترية بصمات الأصابع أو التعرف على الوجه لتسجيل الدخول الآمن. توفر الأنظمة السحابية إمكانية الوصول عبر الجوال والتتبع الفوري. توفر أنظمة بطاقات RFID راحة بدون تلامس. كل نوع له مزايا فريدة اعتماداً على احتياجات أعمالك وميزانيتك.'
              },
              {
                heading: 'الميزات الأساسية التي يجب البحث عنها',
                text: 'تشمل الميزات الأساسية حساب الوقت الإضافي التلقائي وإدارة المناوبات وتكامل الإجازات وإمكانية الوصول عبر الجوال وإعداد التقارير الفورية. بالنسبة للشركات السعودية، يعد دعم اللغة العربية وتكامل التقويم الهجري من المتطلبات الحاسمة.'
              },
              {
                heading: 'التكامل مع الرواتب والموارد البشرية',
                text: 'تتكامل أنظمة الحضور الحديثة بسلاسة مع برامج الرواتب، مما يلغي إدخال البيانات اليدوي ويقلل من الأخطاء. يتيح التكامل مع أنظمة الموارد البشرية إدارة شاملة للموظفين، من التوظيف إلى تقييمات الأداء.'
              },
              {
                heading: 'أفضل ممارسات التطبيق',
                text: 'ابدأ بتقييم واضح للمتطلبات. قم بتدريب الموظفين بشكل شامل على النظام الجديد. نفذ على مراحل لتقليل الاضطراب. تأكد من وجود أنظمة احتياطية. راجع وحسّن بانتظام بناءً على ملاحظات المستخدمين واحتياجات الأعمال.'
              },
              {
                heading: 'الامتثال وأمن البيانات',
                text: 'تحتوي بيانات الحضور على معلومات حساسة عن الموظفين. تأكد من امتثال نظامك للوائح حماية البيانات السعودية. نفذ التشفير وضوابط الوصول وعمليات التدقيق الأمني المنتظمة. اختر الموردين الذين يفهمون متطلبات الامتثال المحلية.'
              },
              {
                heading: 'اعتبارات التكلفة',
                text: 'تشمل التكاليف الأولية الأجهزة وتراخيص البرامج والتركيب. ضع في الاعتبار التكاليف المستمرة مثل الصيانة والدعم والترقيات. عادةً ما توفر الحلول السحابية أسعاراً شهرية يمكن التنبؤ بها، بينما تتطلب الأنظمة المحلية استثمارات مقدمة أكبر ولكن تكاليف متكررة أقل.'
              }
            ],
            conclusion: 'يعد تطبيق نظام الحضور استثماراً في الكفاءة التشغيلية والامتثال القانوني. بالنسبة للشركات الصغيرة والمتوسطة السعودية، يعد اختيار حل يفهم المتطلبات المحلية ويتكامل مع الأنظمة الحالية أمراً بالغ الأهمية. تتخصص أديدو في حلول الحضور المخصصة المصممة للشركات السعودية. اتصل بنا للحصول على استشارة وعرض توضيحي مجاني.'
          },
          tags: ['نظام الحضور', 'تقنية الموارد البشرية', 'المملكة العربية السعودية', 'الشركات الصغيرة والمتوسطة', 'إدارة القوى العاملة']
        },
        {
          id: 'mobile-app-trends-2026',
          slug: 'mobile-app-development-trends-2026',
          title: 'اتجاهات تطوير تطبيقات الجوال في 2026',
          excerpt: 'استكشف أحدث اتجاهات تطوير الجوال التي ستشكل الصناعة هذا العام.',
          category: 'الجوال',
          date: '22 ديسمبر 2025',
          readTime: '6 دقائق قراءة',
          image: app,
          author: 'عدي فهد الدبي',
          authorRole: 'الرئيس التنفيذي',
          content: {
            intro: 'يستمر مشهد تطوير تطبيقات الجوال في التطور بسرعة. مع دخولنا عام 2026، تعيد التقنيات الجديدة وتوقعات المستخدمين تشكيل كيفية بناء تطبيقات الجوال. إليك الاتجاهات الرئيسية التي يجب على كل شركة معرفتها.',
            sections: [
              {
                heading: 'تكامل الذكاء الاصطناعي والتعلم الآلي',
                text: 'لم يعد الذكاء الاصطناعي اختيارياً في تطبيقات الجوال. من التوصيات المخصصة إلى النص التنبؤي والتعرف على الصور، أصبحت نماذج التعلم الآلي ميزات قياسية. يتيح الذكاء الاصطناعي الطرفي المعالجة مباشرة على الأجهزة، مما يوفر استجابات أسرع وخصوصية محسّنة.'
              },
              {
                heading: 'ارتفاع شعبية التطبيقات الفائقة',
                text: 'بعد نجاح WeChat و Grab، تكتسب التطبيقات الفائقة التي تجمع خدمات متعددة في منصة واحدة زخماً عالمياً. يفضل المستخدمون التجارب الموحدة بدلاً من التنقل بين تطبيقات متعددة. هذا الاتجاه قوي بشكل خاص في الأسواق الناشئة ومنطقة دول مجلس التعاون الخليجي.'
              },
              {
                heading: 'تجارب مدعومة بشبكة الجيل الخامس',
                text: 'مع توسع شبكات الجيل الخامس في المملكة العربية السعودية والخليج، يمكن للتطبيقات الآن تقديم محتوى أكثر ثراءً وتجارب متعددة اللاعبين الفورية وبث فيديو عالي الجودة بدون تخزين مؤقت. يقوم المطورون بإنشاء تطبيقات تستفيد بالكامل من هذه القدرات.'
              },
              {
                heading: 'نضج التطوير متعدد المنصات',
                text: 'نضجت Flutter و React Native بشكل كبير، حيث تقدم أداءً قريباً من الأصلي مع مزايا قاعدة التعليمات البرمجية الواحدة. تختار المزيد من المؤسسات نهج متعدد المنصات لتقليل تكاليف التطوير وتسريع الوصول إلى السوق مع الحفاظ على الجودة.'
              },
              {
                heading: 'تعزيز الأمن والخصوصية',
                text: 'مع تزايد اختراقات البيانات، يطالب المستخدمون بأمان أقوى. أصبحت المصادقة البيومترية معياراً، وتظهر بنى الثقة المعدومة، وأصبحت التصاميم التي تعطي الأولوية للخصوصية ميزات تنافسية. التطبيقات التي تتعامل بشفافية مع البيانات تكسب ثقة المستخدم.'
              },
              {
                heading: 'الواقع المعزز يصبح سائداً',
                text: 'ينتقل الواقع المعزز إلى ما وراء الألعاب والمرشحات. تستخدم تطبيقات البيع بالتجزئة الواقع المعزز للتجربة الافتراضية، وتطبيقات العقارات للجولات الافتراضية، وتطبيقات التعليم للتعلم التفاعلي. أصبحت التقنية في متناول الجميع وعملية لتطبيقات الأعمال اليومية.'
              }
            ],
            conclusion: 'يتطلب البقاء في المقدمة في تطوير تطبيقات الجوال فهم هذه الاتجاهات ومعرفة متى يتم اعتمادها. ليس كل اتجاه يناسب كل عمل، لكن البقاء على اطلاع يساعد في اتخاذ قرارات استراتيجية. يبقى فريق تطوير الجوال في أديدو في طليعة هذه التقنيات، ويقدم تطبيقات متطورة للشركات السعودية. دعنا نناقش رؤيتك لتطبيق الجوال.'
          },
          tags: ['تطوير الجوال', 'اتجاهات التطبيقات', 'التقنية', 'iOS', 'Android', '2026']
        },
        {
          id: 'why-odoo-better-than-other-erp',
          slug: 'why-odoo-is-better-than-other-erp-systems',
          title: 'لماذا Odoo أفضل من أنظمة تخطيط موارد المؤسسات التقليدية',
          excerpt: 'أعاد Odoo تعريف ما يجب أن يكون عليه نظام تخطيط موارد المؤسسات الحديث—مرن وقابل للتوسع وفعال من حيث التكلفة ومصمم لاحتياجات الأعمال الحقيقية. إليك لماذا يتفوق باستمرار على أنظمة تخطيط الموارد القديمة.',
          category: 'تخطيط موارد المؤسسات',
          date: 'يناير 2026',
          readTime: '6 دقائق قراءة',
          image: whyodoo,
          author: 'أحمد نور',
          authorRole: 'مطور Odoo الرئيسي',
          content: {
            intro: 'معظم أنظمة تخطيط موارد المؤسسات صُممت لحقبة مختلفة—بطيئة وصارمة ومكلفة ومعادية للتغيير. يكسر Odoo هذا النمط. ليس مجرد نظام تخطيط موارد آخر؛ إنه منصة أعمال معيارية مصممة للشركات التي تحتاج إلى التحرك بسرعة والتكيف باستمرار والبقاء في السيطرة على التكاليف.',
            sections: [
              {
                heading: 'بنية معيارية حقيقية',
                text: 'على عكس أنظمة تخطيط الموارد الضخمة التي تجبرك على شراء كل شيء مقدماً، Odoo معياري بالتصميم. تقوم بتطبيق ما تحتاجه فقط—المبيعات والمحاسبة والمخزون والموارد البشرية والتصنيع—وتوسع مع نمو الأعمال. لا تراخيص مهدرة. لا تطبيقات منتفخة.'
              },
              {
                heading: 'إجمالي تكلفة ملكية أقل',
                text: 'تستنزف أنظمة تخطيط الموارد التقليدية الميزانيات من خلال رسوم الترخيص والترقيات الإجبارية والانغلاق في المورد. يقدم Odoo أسعاراً شفافة ومرونة مفتوحة المصدر وحرية التخصيص. تحصل الشركات على قدرة على مستوى المؤسسة بدون ألم مالي على مستوى المؤسسة.'
              },
              {
                heading: 'تطبيق أسرع وعائد استثمار أسرع',
                text: 'تفشل مشاريع تخطيط الموارد عندما تستغرق وقتاً طويلاً. تطبيقات Odoo أسرع لأن النظام بديهي وقابل للتكوين وصديق للمطورين. تنطلق الشركات بشكل أسرع وتتكيف بشكل أسرع وتبدأ في رؤية عائد الاستثمار في أشهر—وليس سنوات.'
              },
              {
                heading: 'منصة واحدة ومتكاملة بالكامل',
                text: 'تعتمد معظم أنظمة تخطيط الموارد على تكاملات هشة بين وحدات منفصلة. بُني Odoo كمنصة موحدة واحدة. المبيعات تتحدث مع المخزون. المخزون يتحدث مع المحاسبة. تتدفق البيانات بشكل نظيف ومتسق وفي الوقت الفعلي—بدون فوضى البرمجيات الوسيطة.'
              },
              {
                heading: 'مصمم للمستخدمين وليس فقط للمستشارين',
                text: 'أنظمة تخطيط الموارد القديمة قوية ولكنها مؤلمة. يركز Odoo على سهولة الاستخدام. واجهات نظيفة وسير عمل منطقي وتجربة مستخدم حديثة تعني أن الفرق تستخدم النظام فعلاً بدلاً من التحايل عليه. الاعتماد أعلى والأخطاء أقل والإنتاجية تتحسن.'
              },
              {
                heading: 'مفتوح ومرن ومستعد للمستقبل',
                text: 'Odoo مفتوح المصدر في جوهره. هذا يعني عدم الانغلاق في المورد وتخصيص غير محدود. مع تطور أعمالك، يتطور Odoo معك—وحدات جديدة وأتمتة جديدة وتكاملات جديدة. أنت لست محاصر بقرارات الأمس.'
              }
            ],
            conclusion: 'يفوز Odoo لأنه يتماشى مع كيفية عمل الشركات الحديثة فعلاً—سريعة ورقمية ومتغيرة باستمرار. يقدم القوة بدون تعقيد والمرونة بدون فوضى. مقارنة بأنظمة تخطيط الموارد التقليدية، Odoo ليس فقط أفضل. إنه أذكى.'
          },
          tags: [
            'Odoo',
            'تخطيط موارد المؤسسات',
            'برامج الأعمال',
            'التحول الرقمي',
            'أنظمة المؤسسات',
            'مزايا Odoo'
          ]
        },
        {
          id: 'saudi-cyber-security-iso-27001',
          slug: 'saudi-arabia-cyber-security-iso-27001-importance',
          title: 'لماذا الأمن السيبراني و ISO 27001 لم يعودا اختياريين في المملكة العربية السعودية',
          excerpt: 'مع تسارع المملكة العربية السعودية في تحولها الرقمي، أصبح الأمن السيبراني والامتثال لمعيار ISO 27001 ركائز حاسمة لمرونة الأعمال والثقة والبقاء التنظيمي.',
          category: 'الأمن السيبراني',
          date: 'يناير 2026',
          readTime: '6 دقائق قراءة',
          image: cybersecurity,
          author: '',
          authorRole: 'مستشار الأمن السيبراني الرئيسي',
          content: {
            intro: 'المملكة العربية السعودية تتحرك بسرعة. رؤية 2030 تقوم برقمنة كل شيء—الخدمات الحكومية والأنظمة المالية والرعاية الصحية والطاقة والخدمات اللوجستية. السرعة ميزة، لكنها أيضاً ترسم هدفاً. التهديدات السيبرانية تتزايد في الحجم والتعقيد والتأثير المالي. في هذه البيئة، الأمن السيبراني ليس مصدر قلق لتقنية المعلومات. إنه قضية بقاء على مستوى مجلس الإدارة.',
            sections: [
              {
                heading: 'مشهد التهديدات السيبرانية في المملكة العربية السعودية',
                text: 'المؤسسات السعودية من بين الأكثر استهدافاً في الشرق الأوسط. المؤسسات المالية والكيانات الحكومية وشركات النفط والغاز ومقدمي الرعاية الصحية يواجهون تهديدات مستمرة تتراوح من برامج الفدية واختراقات البيانات إلى هجمات الدول القومية. المهاجمون لا يجربون—إنهم يستغلون الثغرات في الحوكمة والتحكم في الوصول والاستجابة للحوادث.'
              },
              {
                heading: 'لماذا ISO 27001 أكثر أهمية من أي وقت مضى',
                text: 'ISO 27001 ليس أوراقاً. إنه إطار منظم معترف به عالمياً يجبر المؤسسات على فهم مخاطرها والتحكم في أصولها والاستجابة بفعالية للحوادث. في المملكة العربية السعودية، يتماشى ISO 27001 مباشرة مع التوقعات التنظيمية ومتطلبات الهيئة الوطنية للأمن السيبراني وثقة العملاء. إنه يستبدل التخمين بالانضباط.'
              },
              {
                heading: 'الأمن السيبراني كممكّن للأعمال',
                text: 'الأمن السيبراني القوي ليس عائقاً—إنه مسرّع. المؤسسات ذات برامج الأمن الناضجة تتحرك بشكل أسرع لأنها تثق في أنظمتها. إنها تضم الشركاء بثقة وتعتمد تقنيات السحابة بأمان وتتوسع بدون خوف. الأمن يمكّن النمو عندما يكون مدمجاً وليس مضافاً.'
              },
              {
                heading: 'الضغط التنظيمي يتزايد',
                text: 'المنظمون السعوديون يرفعون المعايير. الامتثال لأطر الأمن السيبراني الوطنية لم يعد اختيارياً، والإنفاذ أصبح أكثر صرامة. المؤسسات التي تؤجل الاستثمار في حوكمة أمن المعلومات ستدفع لاحقاً—من خلال الغرامات أو الاضطراب التشغيلي أو الضرر بالسمعة.'
              },
              {
                heading: 'تكلفة عدم التحرك',
                text: 'اختراق واحد يمكن أن يمحو سنوات من النمو. فقدان البيانات وتوقف الخدمة والتعرض القانوني والفقدان العام للثقة ليست مخاطر افتراضية—إنها حقائق يومية. المؤسسات التي تعامل الأمن السيبراني كفكرة لاحقة تقامر بمستقبلها.'
              }
            ],
            conclusion: 'في اقتصاد المملكة العربية السعودية الرقمي، الأمن السيبراني هو أصل استراتيجي. يوفر ISO 27001 الهيكل والوضوح والمصداقية التي تحتاجها المؤسسات لحماية نفسها والنمو بثقة. السؤال لم يعد ما إذا كنا نستثمر في الأمن السيبراني—بل هل يمكنك تحمل عدم القيام بذلك.'
          },
          tags: [
            'الأمن السيبراني',
            'ISO 27001',
            'المملكة العربية السعودية',
            'أمن المعلومات',
            'إدارة المخاطر',
            'رؤية 2030'
          ]
        }
      ]
    },

    // Contact Section
    contact: {
      title: 'تواصل معنا',
      subtitle: 'لنناقش مشروعك القادم',
      form: {
        name: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        phone: 'رقم الجوال',
        company: 'اسم الشركة',
        service: 'الخدمة المهتم بها',
        message: 'تفاصيل المشروع',
        submit: 'إرسال الرسالة',
        sending: 'جاري الإرسال...',
        success: 'تم إرسال الرسالة بنجاح! سنعود إليك قريباً.',
        error: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.'
      },
      info: {
        email: 'info@adidoo.com',
        phone: '+966 551826405',
        address: 'الرياض، المملكة العربية السعودية',
        hours: 'الأحد - الخميس: 9:00 صباحاً - 6:00 مساءً'
      }
    },

    // Footer
    footer: {
      tagline: 'نحول الأعمال بحلول تقنية مبتكرة',
      company: {
        title: 'الشركة',
        links: ['من نحن', 'الوظائف', 'الشركاء', 'الأخبار']
      },
      services: {
        title: 'الخدمات',
        links: ['Odoo ERP', 'تطوير الويب', 'تطبيقات الجوال', 'الأمن السيبراني', 'الاستشارات التقنية']
      },
      support: {
        title: 'الدعم',
        links: ['التوثيق', 'مركز المساعدة', 'اتصل بنا', 'الأسئلة الشائعة']
      },
      legal: {
        title: 'قانوني',
        links: ['سياسة الخصوصية', 'شروط الخدمة', 'سياسة ملفات تعريف الارتباط']
      },
      copyright: '© 2026 أديدو. جميع الحقوق محفوظة.'
    }
  }
};
